import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ADPResourceService } from 'digital-core';
import { ChatHandler } from 'src/app/core/handler/chat-handler';
import { PGHOktaService } from 'src/app/core/services/pghokta.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { AsappChatService } from '../../core/services/asapp-chat.service';

@Component({
  selector: 'pgh-tech-support',
  templateUrl: './tech-support.component.html',
  styleUrls: ['./tech-support.component.scss'],
})
export class TechSupportComponent implements OnInit {
  @Output() letsChatClicked = new EventEmitter();
  headerKey: string = 'TechSupport_CantLogin';
  isAuthenticated = false;
  chatOffHoursStartTimeInUTC = '4';
  chatOffHoursEndTimeInUTC = '12';
  isChatAvailable = false;

  constructor(
    private matDialog: MatDialog,
    public route: ActivatedRoute,
    private utilityService: UtilityService,
    private resourceService: ADPResourceService,
    private activatedRoute: ActivatedRoute,
    private pghOktaService: PGHOktaService,
    private asappChatService: AsappChatService
  ) {}

  ngOnInit(): void {
    this.chatOffHoursStartTimeInUTC = this.resourceService.getPortalSetting('Chat_OffHours_StartTime_UTC24HT')?.Value ?? '4';
    this.chatOffHoursEndTimeInUTC = this.resourceService.getPortalSetting('Chat_OffHours_EndTime_UTC24HT')?.Value ?? '12';
    this.isAuthenticated = this.pghOktaService.isTokenValid();
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['headerKey'] != null) {
        this.headerKey = params['headerKey'];
      } else if (this.isAuthenticated) {
        this.headerKey = 'TechSupport_HavingTrouble';
      }
    });
    this.getLiveChatAvailability();
  }

  letsChat() {
    this.letsChatClicked.emit();
    const rnWindow = window as any;
    if (rnWindow.ReactNativeWebView) {
      const message = JSON.stringify({ action: 'openChat', args: {} });
      rnWindow.ReactNativeWebView.postMessage(message);
    }

    // Show chat or not available dialog
    const chatHandler = new ChatHandler(this.matDialog, this.resourceService, this.utilityService, this.route, this.asappChatService);
    chatHandler.openChatInterface();
  }

  getLiveChatAvailability() {
    // check if chat bubble button is active, not being used in lower environments, let the default button click handle it
    // leaving for now for reference if needed later
    const button: HTMLElement = document.querySelector('.helpButtonEnabled');

    if (button) {
      // this only checks if we are within the active hours and set the flag to true or false
      const now = new Date();
      if (now.getUTCHours() >= parseInt(this.chatOffHoursStartTimeInUTC) && now.getUTCHours() < parseInt(this.chatOffHoursEndTimeInUTC)) {
        // if outside hours, chat is offline
        this.isChatAvailable = false;
      } else {
        // chat is online
        this.isChatAvailable = true;
      }
    } else {
      // if chat bubblde is not active, then chat is offline
      this.isChatAvailable = false;
    }
  }
}
